import usePageWrapper from "PFCore/helpers/use_page_wrapper";
import React from "react";

import RolesGanttView from "./roles_gantt_view";
import RolesTable from "./roles_table";
import useRolesTab from "./use_roles_tab";

const RolesTab = () => {
  const { loaded, ganttView } = useRolesTab();
  const WrappedTab = usePageWrapper(ganttView ? RolesGanttView : RolesTable);
  return <WrappedTab loading={!loaded} />;
};

export default RolesTab;
